<template>
  <Layout>
    <section class="section">
      <div class="container">
        <div class="no-free-will">
          <h3>Joining WebEx meetings</h3>
          <p>
            Extraordinary circumstances associated with the coronavirus pandemic
            have severely curtailed international travel and necessitated the
            imposition of physical distancing measures. Such measures preclude
            the holding of large conferences in such venues as convention halls.
          </p>
          <p>
            As a firm, we have consistently worked to safeguard the health and
            safety of our stakeholders. EFG Hermes and Tadawul have put together this virtual
            conference during these unprecedented times to support each and
            every one of the participants that have been instrumental in making
            our conferences a success. The conference will deliver the valuable
            insights and analyses participants have become accustomed to right
            to your laptops, tablets, and smartphones.
          </p>
          <p>
            Click on the links below for instructions on how to join the digital
            meetings.
          </p>
        </div>
        <div class="no-free-will">
          <div class="row">
            <div class="bottom-links">
              <div class="col-md-6">
                <a
                  href="http://testbed.inktankcommunications.com/efg-websites/1x1/2020/pdf/joining-webex-meetings-for-investors.pdf"
                  class="btn btn-sm btn-secondary btn-block"
                  download
                  >Investors</a
                >
              </div>
              <div class="col-md-6">
                <a
                  href="http://testbed.inktankcommunications.com/efg-websites/1x1/2020/pdf/joining-webex-meetings-for-companies.pdf"
                  class="btn btn-sm btn-secondary btn-block"
                  download
                  >Presenting Companies</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";

export default {
  name: "WebexGuide",
  components: { Layout },
};
</script>
